import React from "react";
import PropTypes from "prop-types";
import { Card, Row, Col, List } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { RadarChart } from "@unifiedpatents/euclid-react";
import { nestedObjectsToGroupedSeries } from "@unifiedpatents/euclid-react/lib/helpers/preprocessors";
import { isNumber } from "lodash";

const PatentRatingsRadarChart = props => {
  const { data, domains, width, height } = props;
  const chartProps = {
    data: nestedObjectsToGroupedSeries({ ratings: data }),
    labelAttrs: domains,
    tickFormat: v => isNumber(v) ? Math.round(v) : v,
    width: width,
    height: height
  };
  return <RadarChart {...chartProps} />;
};
PatentRatingsRadarChart.propTypes = {
  data: PropTypes.object.isRequired,
  domains: PropTypes.object.isRequired,
  width: PropTypes.number,
  height: PropTypes.number
};
PatentRatingsRadarChart.defaultProps = {
  width: 300,
  height: 300
};

const PatentRatings = props => {
  const ratings = {
    RUBY: { D: 1, C: 2, B: 3, A: 4, AA: 5 }[props.data.rating_litigation] || 0,
    BRIX: { D: 1, C: 2, B: 3, A: 4, AA: 5 }[props.data.rating_broadness] || 0,
    CITX: { D: 1, C: 2, B: 3, A: 4, AA: 5 }[props.data.rating_citation] || 0,
    PVIX: props.data.portfolio_score ? Number.parseFloat(props.data.portfolio_score.toFixed(2)) : 0,
    RNIX: props.data.rnix_score ? Number.parseFloat(props.data.rnix_score.toFixed(2)) : 0,
    SVIX: props.data.norm_family_annuities ? Number.parseFloat(props.data.norm_family_annuities.toFixed(2)) : 0
  };
  const domainLabels = {
    0: "",
    1: "D",
    2: "C",
    3: "B",
    4: "A",
    5: "AA"
  };
  const numberToLabel = v => domainLabels[Math.round(v)];
  const domains = {
    BRIX: {
      domain: [0, 5],
      domainLabels: domainLabels
    },
    CITX: {
      domain: [0, 5],
      domainLabels: domainLabels
    },
    RUBY: {
      domain: [0, 5],
      domainLabels: domainLabels
    },
    PVIX: {
      domain: [0, 100],
    },
    RNIX: {
      domain: [-100, 100],
    },
    SVIX: {
      domain: [0, 100],
    }
  };
  const title = [
    "Patent Ratings ",
    <a href="//support.unifiedpatents.com/hc/en-us/articles/115001550673" target="_new" key="exp-link">
      <QuestionCircleOutlined />
    </a>
  ];
  return (
    <Card title={title}>
      <Row gutter={16}>
        <Col span={16} type="flex" justify="center" align="middle">
          <PatentRatingsRadarChart data={ratings} domains={domains} />
        </Col>
        <Col span={8}>
          <List
            dataSource={["RUBY", "CITX", "BRIX", "PVIX", "RNIX", "SVIX"]}
            renderItem={k => (
              <List.Item>
                <b><small>{`${k}: `}</small></b><br />
                {`${domains[k].domainLabels ? numberToLabel(ratings[k]) : ratings[k]}`}
              </List.Item>
            )}
            grid={{ gutter: 4, column: 1 }}
            size="small"
          />
        </Col>
      </Row>
    </Card>
  );
};

PatentRatings.propTypes = {
  data: PropTypes.object.isRequired
};

export default PatentRatings;
